import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const getFMSProductName = (productName: string): string => {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (productName) {
    case INSURANCE_NAME_VALUE.ANIMAL:
      return "animal";
    case INSURANCE_NAME_VALUE.BOAT:
      return "boat";
    case INSURANCE_NAME_VALUE.CABIN:
      return "cabin";
    case INSURANCE_NAME_VALUE.CABIN_CONTENTS:
      return "cabinContents";
    case "AUTO": // tmp until backend changes are released
    case INSURANCE_NAME_VALUE.CAR:
      return "car";
    case INSURANCE_NAME_VALUE.CAR_NORSK_ELBILFORENING:
      return "carNorskElbilforening";
    case INSURANCE_NAME_VALUE.CARAVAN:
      return "caravan";
    case INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER:
      return "electricScooter";
    case INSURANCE_NAME_VALUE.AKA_CHILD:
      return "akaChild";
    case INSURANCE_NAME_VALUE.CHILD:
      return "child";
    case INSURANCE_NAME_VALUE.CHILD_HEALTH:
      return "childHealth";
    case INSURANCE_NAME_VALUE.NEW_CHILD:
      return "child"; //add new child?
    case INSURANCE_NAME_VALUE.DEATH:
      return "death";
    case INSURANCE_NAME_VALUE.HOUSE:
      return "house";
    case INSURANCE_NAME_VALUE.AKA_HOUSE_CONTENTS:
      return "akaHouseContents";
    case INSURANCE_NAME_VALUE.HOUSE_CONTENTS:
      return "houseContents";
    case INSURANCE_NAME_VALUE.MOPED:
      return "moped";
    case INSURANCE_NAME_VALUE.MOTORCYCLE:
      return "motorcycle";
    case INSURANCE_NAME_VALUE.TRACTOR:
      return "tractor";
    case INSURANCE_NAME_VALUE.TRAILER:
      return "trailer";
    case INSURANCE_NAME_VALUE.AKA_TRAVEL:
      return "akaTravel";
    case INSURANCE_NAME_VALUE.TRAVEL:
      return "travel";
    case INSURANCE_NAME_VALUE.VALUABLES:
      return "valuables";
    case INSURANCE_NAME_VALUE.VETERAN_AUTO:
      return "veteranAuto";
    case INSURANCE_NAME_VALUE.AKA_STUDENT:
      return "akaStudent";
    case INSURANCE_NAME_VALUE.AKA_HEALTH:
    case INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING:
      return "akaHealth";
    case INSURANCE_NAME_VALUE.AKA_FAMILY_ACCIDENT:
      return "akaFamilyAccident";
    case INSURANCE_NAME_VALUE.AKA_GROUP_LIFE:
      return "akaGroupLife";
    case INSURANCE_NAME_VALUE.AKA_CRITICAL_ILLNESS:
      return "akaCriticalIllness";
    case INSURANCE_NAME_VALUE.ACCIDENT:
      return "accident";
    case INSURANCE_NAME_VALUE.DISABILITY_FLEX:
      return "disabilityFlex";
    case INSURANCE_NAME_VALUE.CRITICAL_ILLNESS:
      return "criticalIllness";
    case INSURANCE_NAME_VALUE.HEALTH:
    case INSURANCE_NAME_VALUE.HEALTH_WITHOUT_SIGNING:
      return "health";
    case INSURANCE_NAME_VALUE.RENTAL:
      return "rental";
    case INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE:
      return "sopSicknessLeave";
    case INSURANCE_NAME_VALUE.HUSEIERNE_HOUSE_CONTENTS:
      return "huseierneHouseContents";
    case INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN:
      return "pregnantAndNewborn";
    case ProductBackendName.ADVICE:
      return "advice";
    default:
      return "";
  }
};
